export const WATERMARK_CONFIG = {
	text: "ImagesArt.ai",
	position: "top-right" as const,
	fontSize: 36,
	color: "rgba(255, 255, 255, 0.4)",
	margin: 30,
	opacity: 0.6,
} as const;

export const DEFAULT_WATERMARK_SETTINGS = {
	enabledForFreeUsers: true,
	enabledForPaidUsers: false,
} as const;
